import { Link } from 'react-router-dom';
import { hotComics, comics, categories } from '@/mocks/comics';
import ComicCard from '@/components/feature/ComicCard';

export default function HotSection() {
  const hotData = hotComics.map((id) => comics.find((c) => c.id === id)!);

  return (
    <section className="py-12 md:py-16">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          {/* Header */}
          <div className="flex items-end justify-between mb-8">
            <div>
              <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900">
                热门推荐
              </h2>
              <p className="text-sm text-foreground-500 mt-1">大家都在看的高人气漫画</p>
            </div>
            <Link
              to="/category/hanman"
              className="flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 font-medium whitespace-nowrap"
            >
              查看全部
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>

          {/* Grid */}
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-4 md:gap-5">
            {hotData.slice(0, 12).map((comic) => (
              <ComicCard
                key={comic.id}
                id={comic.id}
                title={comic.title}
                author={comic.author}
                cover={comic.cover}
                category={comic.category}
                categoryName={categories.find((c) => c.slug === comic.category)?.name || ''}
                rating={comic.rating}
                tags={comic.tags}
                status={comic.status}
                size="sm"
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}